(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-steps"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', (e) => {
    document.querySelectorAll('.step-nav').forEach((item) => {
        item.addEventListener('click', (e) => {
            const el = document.querySelector(`.product-steps__step[data-step="${item.dataset.target}"]`);
            window.scrollTo({
                top: el.offsetTop - 120,
                behaviour: 'smooth'
            })
        });
    });

    document.querySelectorAll('.js-step-scroll').forEach((wrapper) => {
        let productCardImage = wrapper.querySelector('.product-card .primary-image'),
        scrollControls = wrapper.querySelector('.js-scroll-controls');

        if(!!scrollControls){
            scrollControls.style.top = `${Math.round(productCardImage.clientHeight / 2 + 14)}px`;
        }
    });
});

  } catch(e) { console.error(e); }
})();
})();
